import { typographyVariants } from '@mint-lib/tw-components';

import { colorToHex, formatLabel } from '../../../helpers/charts.js';

type Props = {
  y: string[];
  colors: string[];
};

const BarChartLegend = ({ y, colors }: Props) => {
  return (
    <div
      data-legend // Property for casting to SVG
      className={
        'flex w-full max-w-175 flex-row flex-wrap items-center justify-start gap-2 pl-10'
      }
    >
      {y?.map((yItem, i) => (
        <div className="flex items-center gap-1" key={yItem}>
          <div
            style={{ backgroundColor: colorToHex(colors[i % colors.length]) }}
            className="flex size-2.5 shrink-0 flex-row"
          />

          <p className={typographyVariants({ variant: 'bodyLong01' })}>
            {formatLabel(yItem)}
          </p>
        </div>
      ))}
    </div>
  );
};

export default BarChartLegend;
